<h4>Billing</h4>

<form>
  <mat-radio-group aria-label="Select an option" [disabled]="isDisabled" [value]="value" (change)="changeBillingType($event)">
    <mat-radio-button value="Dual" style="margin-right: 10px">Dual</mat-radio-button>
    <mat-radio-button value="Consolidated">Consolidated</mat-radio-button>
  </mat-radio-group>
</form>
